<app-collapsible-section 
title="Facebook"
[isExpanded]="isExpanded"
[isCompleted]="isCompleted"
[showDoneButton]="true"
(toggle)="onFacebookToggle($event)"
(done)="onFacebookDone()">
<ng-template #sectionContent>
 <!-- Preview Section -->
 <div class="preview-section">
    <div class="create-email-input" *ngIf="!hasFacebookContent()" (click)="openCreateModal()">
        <div class="input-content">
          <span class="input-text">Create Facebook Ad Campaign</span>
        </div>
        <div class="plus-icon">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1V13M1 7H13" stroke="#0030A8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    <div class="preview-header" *ngIf="hasFacebookContent()">
      <div class="preview-title-section">
        <h4 class="preview-title">Your Message Preview</h4>
      </div>
      <div class="preview-actions">
        <button class="action-btn edit-btn" (click)="openCreateModal()">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.66797 3.66674H3.0013C2.64768 3.66674 2.30854 3.80721 2.05849 4.05726C1.80844 4.30731 1.66797 4.64645 1.66797 5.00007V11.0001C1.66797 11.3537 1.80844 11.6928 2.05849 11.9429C2.30854 12.1929 2.64768 12.3334 3.0013 12.3334H9.0013C9.35492 12.3334 9.69406 12.1929 9.94411 11.9429C10.1942 11.6928 10.3346 11.3537 10.3346 11.0001V10.3334M9.66797 2.3334L11.668 4.3334M12.5913 3.39007C12.8539 3.12751 13.0014 2.77139 13.0014 2.40007C13.0014 2.02875 12.8539 1.67264 12.5913 1.41007C12.3287 1.14751 11.9726 1 11.6013 1C11.23 1 10.8739 1.14751 10.6113 1.41007L5.0013 7.00007V9.00007H7.0013L12.5913 3.39007Z" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
        </button>
        <button class="action-btn delete-btn" (click)="onDeleteMessage()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.66797 4.66667H13.3346M6.66797 7.33333V11.3333M9.33464 7.33333V11.3333M3.33464 4.66667L4.0013 12.6667C4.0013 13.0203 4.14178 13.3594 4.39183 13.6095C4.64187 13.8595 4.98101 14 5.33464 14H10.668C11.0216 14 11.3607 13.8595 11.6108 13.6095C11.8608 13.3594 12.0013 13.0203 12.0013 12.6667L12.668 4.66667M6.0013 4.66667V2.66667C6.0013 2.48986 6.07154 2.32029 6.19656 2.19526C6.32159 2.07024 6.49116 2 6.66797 2H9.33464C9.51145 2 9.68102 2.07024 9.80604 2.19526C9.93106 2.32029 10.0013 2.48986 10.0013 2.66667V4.66667" stroke="#AF1820" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
        </button>
      </div>
    </div>
    <div class="preview-content-fb" *ngIf="hasFacebookContent()">
      <ng-container *ngTemplateOutlet="facebookAdPreview"></ng-container>
    </div>
    <div class="form-footer" >
        <button class="btn btn-primary btn-medium" (click)="onFacebookDone()">{{hasFacebookContent() ? 'Done' : 'Create'}}</button>
    </div>
    </div>
</ng-template>
</app-collapsible-section>

<!-- Create Facebook Ad Modal -->
<div class="modal-overlay" *ngIf="showCreateModal" (click)="closeCreateModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Create Facebook Ad Campaign</h2>
      <button class="close-btn" (click)="closeCreateModal()">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5 1.5L1.5 13.5M1.5 1.5L13.5 13.5" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
      </button>
    </div>
    
    <div class="modal-body">
      <div class="modal-body-content"
      >
        <div class="form-section">
          <div class="form-fields">
            <!-- Logo Upload -->
            <div class="upload-section">
              <label class="upload-label">Logo<span class="required">*</span></label>
              <div class="upload-container" [class.error]="validationErrors.logo">
                <div class="file-upload-area" *ngIf="!facebookAdData.logo && !facebookAdData.logoUrl" 
                     (dragover)="onDragOver($event)" 
                     (dragleave)="onDragLeave($event)" 
                     (drop)="onLogoDrop($event)">
                  <input type="file" id="logo-upload" accept=".png,.jpg,.jpeg" (change)="onLogoUpload($event)" class="file-input">
                  <label for="logo-upload" class="file-upload-label">
                    <ng-container *ngTemplateOutlet="uploadCommonContent"></ng-container>
                    <span class="file-info">Recommended Size: 1080 x 1080 pixels </span>
                    <span class="file-info">Aspect Ratio: 1:1 </span>
                    
                  </label>
                </div>
  
                <div class="file-uploaded" *ngIf="facebookAdData.logo || facebookAdData.logoUrl">
                  <div class="success-icon" *ngIf="!isUploadingLogo">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="6" fill="#079271" />
                      <path d="M5.5 8L7 9.5L10.5 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div class="loading-icon" *ngIf="isUploadingLogo">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="animate-spin">
                      <circle cx="8" cy="8" r="6" stroke="#1B5BFF" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                        <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite" />
                        <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite" />
                      </circle>
                    </svg>
                  </div>
                  <span class="file-name">{{ facebookAdData.logo?.name || facebookAdData.logoUrl }}</span>
                  <button class="remove-file" (click)="removeLogo()" [disabled]="isUploadingLogo">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 3L3 9M3 3L9 9" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="error-message" *ngIf="validationErrors.logo">{{ validationErrors.logo }}</div>
            </div>
  
            <!-- Image Upload -->
            <div class="upload-section">
              <label class="upload-label">Image<span class="required">*</span></label>
              <div class="upload-container" [class.error]="validationErrors.image">
                <div class="file-upload-area" *ngIf="!facebookAdData.image && !facebookAdData.imageUrl" 
                     (dragover)="onDragOver($event)" 
                     (dragleave)="onDragLeave($event)" 
                     (drop)="onImageDrop($event)">
                  <input type="file" id="image-upload" accept=".png,.jpg,.jpeg" (change)="onImageUpload($event)" class="file-input">
                  <label for="image-upload" class="file-upload-label">
                    <ng-container *ngTemplateOutlet="uploadCommonContent"></ng-container>
                    <span class="file-info">Recommended Size: 1200 x 628 pixels </span>
                    <span class="file-info">Aspect Ratio: 1.91:1 </span>
                  </label>
                </div>
  
                <div class="file-uploaded" *ngIf="facebookAdData.image || facebookAdData.imageUrl">
                  <div class="success-icon" *ngIf="!isUploadingImage">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="6" fill="#079271" />
                      <path d="M5.5 8L7 9.5L10.5 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div class="loading-icon" *ngIf="isUploadingImage">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="animate-spin">
                      <circle cx="8" cy="8" r="6" stroke="#1B5BFF" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                        <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite" />
                        <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite" />
                      </circle>
                    </svg>
                  </div>
                  <span class="file-name">{{ facebookAdData.image?.name || facebookAdData.imageUrl }}</span>
                  <button class="remove-file" (click)="removeImage()" [disabled]="isUploadingImage">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 3L3 9M3 3L9 9" stroke="#A7ABB3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="error-message" *ngIf="validationErrors.image">{{ validationErrors.image }}</div>
            </div>
  
            <!-- Name Field -->
            <div class="form-field">
              <label class="field-label">Name<span class="required">*</span></label>
              <input type="text" class="form-input" [class.error]="validationErrors.name" placeholder="ABC Wash" [(ngModel)]="facebookAdData.name" maxlength="100" (keypress)="onNameKeyPress($event)" (input)="onNameInput($event)">
              <div class="error-message" *ngIf="validationErrors.name">{{ validationErrors.name }}</div>
            </div>
  
            <!-- Caption Field -->
            <div class="form-field">
              <label class="field-label">Caption<span class="required">*</span></label>
              <textarea class="form-textarea" [class.error]="validationErrors.caption" placeholder="50% off your next car wash this black friday!" [(ngModel)]="facebookAdData.caption" maxlength="500"></textarea>
              <div class="error-message" *ngIf="validationErrors.caption">{{ validationErrors.caption }}</div>
            </div>
  
            <!-- Headline Field -->
            <div class="form-field">
              <label class="field-label">Headline<span class="required">*</span></label>
              <input type="text" class="form-input" [class.error]="validationErrors.headline" placeholder="50% Off!" [(ngModel)]="facebookAdData.headline" maxlength="100">
              <div class="error-message" *ngIf="validationErrors.headline">{{ validationErrors.headline }}</div>
            </div>
  
            <!-- Button Text Field -->
            <div class="form-field">
              <label class="field-label">Add the button text here<span class="required">*</span></label>
              <input type="text" class="form-input" [class.error]="validationErrors.buttonText" placeholder="Shop Now" [(ngModel)]="facebookAdData.buttonText" maxlength="50">
              <div class="error-message" *ngIf="validationErrors.buttonText">{{ validationErrors.buttonText }}</div>
            </div>
          </div>
        </div>
  
        <!-- Preview Section -->
        <div class="preview-section-modal">
          <div class="preview-header-modal">
            <h3 class="preview-title-modal">Facebook Ad Preview</h3>
          </div>
          <div class="facebook-preview">
            <ng-container *ngTemplateOutlet="facebookAdPreview"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary btn-medium" (click)="closeCreateModal()">Close</button>
      <button class="btn btn-primary btn-medium" (click)="saveFacebookAd()">Save</button>
    </div>
  </div>
</div>

<!-- Facebook Ad Preview Template (reused in main view and create modal) -->
<ng-template #facebookAdPreview>
  <app-facebook-ad-preview
    [businessName]="facebookAdData.name || ''"
    [discountText]="facebookAdData.caption || ''"
    [discountPercentage]="facebookAdData.headline || ''"
    [ctaText]="facebookAdData.buttonText || ''"
    [logoUrl]="getLogoUrl()"
    [imageUrl]="getImageUrl()"
    [likes]="129"
    [comments]="12"
    [shares]="8">
  </app-facebook-ad-preview>
</ng-template>

<!-- Upload icon + text shared by logo and image upload fields -->
<ng-template #uploadCommonContent>
  <div class="upload-icon">
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.9648 13.1152V16.4486C17.9648 16.8906 17.7892 17.3145 17.4767 17.6271C17.1641 17.9396 16.7402 18.1152 16.2982 18.1152H4.63151C4.18948 18.1152 3.76556 17.9396 3.453 17.6271C3.14044 17.3145 2.96484 16.8906 2.96484 16.4486V13.1152" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.6302 7.2819L10.4635 3.11523L6.29688 7.2819" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10.4648 3.11523V13.1152" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <span class="upload-text mobile-hide">Drag & drop your files here or <strong>browse</strong> to upload</span>
  <span class="upload-text mobile-show"> <span class="link">Click here</span>  to upload image</span>
  <span class="file-info">.png, .jpg, .jpeg Max file size - 5MB</span>
</ng-template>
